import { ReactNode } from 'react';
import Navbar from './Navbar';
import { FooterB } from './Footer';

interface LayoutProps {
  children: ReactNode;
  showSecondaryNav?: boolean;
}

export const Layout = ({ children, showSecondaryNav = false }: LayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col bg-green-200">
      <Navbar />
      {showSecondaryNav && <div className="w-full">{/* SecondaryNavbar would go here */}</div>}
      <main className="flex-grow flex flex-col">
        {children}
      </main>
      <div className="mt-auto">
        <FooterB />
      </div>
    </div>
  );
}
